import { StatusTagProps } from
    '../../../../common/components/load-card/load-card-header/ILoadCardHeader';
import IOffer from '../../../../common/interfaces/offers/IOffer';
import i18n from '../../../../lib/i18n';

export const getAcceptedRateByVehicle = (offer: IOffer) =>
    offer.load.ratesByVehicle?.find(rate => rate.isAccepted);

export default function getOfferTagStatusType(
    roundPhase: 'Acceptance' | 'Confirmation' | null,
    accepted: boolean,
    confirmed: boolean,
): StatusTagProps {
    if (roundPhase === 'Acceptance') {
        if (accepted) {
            return {
                type: 'positive',
                id: 'offer-tag-accepted',
                dataTestId: 'offer-tag-accepted',
                label: i18n.t('SmartCargas.Rounds.Accepted'),
            };
        }

        return {
            type: 'neutral',
            id: 'offer-tag-waiting-acceptance',
            dataTestId: 'offer-tag-waiting-acceptance',
            label: i18n.t('SmartCargas.Rounds.WaitingAcceptance'),
        };
    }

    if (roundPhase === 'Confirmation') {
        if (confirmed) {
            return {
                type: 'positive',
                id: 'offer-tag-confirmed',
                dataTestId: 'offer-tag-confirmed',
                label: i18n.t('SmartCargas.Rounds.Confirmed'),
            };
        }
        return {
            type: 'neutral',
            id: 'offer-tag-waiting-confirmation',
            dataTestId: 'offer-tag-waiting-confirmation',
            label: i18n.t('SmartCargas.Rounds.WaitingConfirmation'),
        };
    }

    return {
        type: 'neutral',
        id: 'offer-tag-undefined',
        dataTestId: 'offer-tag-undefined',
        label: i18n.t('SmartCargas.Rounds.Undefined'),
    };
}
